import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-569b99eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"max-width":"850px"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col",
    style: {"display":"flex","align-items":"baseline"}
  }, [
    /*#__PURE__*/_createElementVNode("h2", null, "New Sales Cohorts")
  ])
], -1))
const _hoisted_3 = { class: "row mb-3" }
const _hoisted_4 = { class: "col-12 col-md-6" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label mb-1",
  for: "modelStartDate"
}, " start date inclusive ", -1))
const _hoisted_6 = { class: "col-12 col-md-6" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label mb-1",
  for: "modelEndDate"
}, " end date exclusive ", -1))
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = { class: "col-12 col-md-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label mb-1",
  for: "branches"
}, " filter by branches ", -1))
const _hoisted_11 = { class: "col-12 col-md-6" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label mb-1",
  for: "revenueTypes"
}, " filter by revenue types ", -1))
const _hoisted_13 = { class: "row mb-3" }
const _hoisted_14 = { class: "col-12 col-md-6" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label mb-1",
  for: "cohortPeriod"
}, " cohort selection period ", -1))
const _hoisted_16 = { class: "col-12 col-md-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label mb-1",
  for: "resultPeriod"
}, " results period ", -1))
const _hoisted_18 = { class: "row mb-3 align-items-end" }
const _hoisted_19 = { class: "col-12 col-md-6" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label mb-1",
  for: "band-name"
}, " new cohort band name ", -1))
const _hoisted_21 = { class: "col-12 col-md-4" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label mb-1",
  for: "band-from"
}, " from cohort revenue inclusive ", -1))
const _hoisted_23 = { class: "col-12 col-md-2" }
const _hoisted_24 = { class: "col-12 col-md-6" }
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = { class: "col-12 col-md-4" }
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = { class: "col-12 col-md-2" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_31 = { class: "row mb-3 align-items-end" }
const _hoisted_32 = { class: "col-12 col-md-2" }
const _hoisted_33 = { class: "col-12 col-md-4" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label mb-1",
  for: "metric"
}, " results metric ", -1))
const _hoisted_35 = {
  key: 0,
  class: "col-12 col-md-2"
}
const _hoisted_36 = {
  key: 0,
  class: "alert alert-primary",
  style: {"max-width":"413px"}
}
const _hoisted_37 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_38 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cohort-row__date" }, "Start", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cohort-row__band" }, "Band", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, null, -1))
const _hoisted_42 = { class: "cohort-row__date" }
const _hoisted_43 = { class: "cohort-row__band" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { key: 2 }
const _hoisted_47 = { key: 3 }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_date_picker = _resolveComponent("k-date-picker")!
  const _component_k_multi_select = _resolveComponent("k-multi-select")!
  const _component_k_drop_down_list = _resolveComponent("k-drop-down-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_k_date_picker, {
            id: "modelStartDate",
            modelValue: _ctx.modelStartDate,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelStartDate) = $event)),
            class: "form-control",
            format: "d MMM yyyy"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_k_date_picker, {
            id: "modelEndDate",
            modelValue: _ctx.modelEndDate,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelEndDate) = $event)),
            class: "form-control",
            format: "d MMM yyyy"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_k_multi_select, {
            id: "branches",
            class: "form-control",
            "data-items": _ctx.allBranches,
            "auto-bind": true,
            "data-item-key": "id",
            "text-field": "name",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.model.branches = $event.target.value.map(o => o.id)))
          }, null, 8, ["data-items"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_k_multi_select, {
            id: "revenueTypes",
            modelValue: _ctx.model.revenueTypes,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.revenueTypes) = $event)),
            class: "form-control",
            "data-items": _ctx.allRevenueTypes
          }, null, 8, ["modelValue", "data-items"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_k_drop_down_list, {
            id: "cohortPeriod",
            modelValue: _ctx.model.cohortPeriod,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.cohortPeriod) = $event)),
            class: "form-control",
            "data-items": _ctx.allPeriods
          }, null, 8, ["modelValue", "data-items"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_component_k_drop_down_list, {
            id: "resultPeriod",
            modelValue: _ctx.model.resultPeriod,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.resultPeriod) = $event)),
            class: "form-control",
            "data-items": _ctx.allPeriods
          }, null, 8, ["modelValue", "data-items"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _withDirectives(_createElementVNode("input", {
            id: "band-name",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.band.name) = $event)),
            class: "form-control",
            type: "text"
          }, null, 512), [
            [_vModelText, _ctx.band.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _withDirectives(_createElementVNode("input", {
            id: "band-from",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.band.from) = $event)),
            class: "form-control",
            type: "number"
          }, null, 512), [
            [_vModelText, _ctx.band.from]
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.addBand && _ctx.addBand(...args)))
          }, "Add Band")
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.revenueBands, (b) => {
        return (_openBlock(), _createElementBlock("div", {
          key: b.key,
          class: "row mb-3 revenue-bands"
        }, [
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": ($event: any) => ((b.name) = $event),
              class: "form-control",
              type: "text"
            }, null, 8, _hoisted_25), [
              [_vModelText, b.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": ($event: any) => ((b.from) = $event),
              class: "form-control",
              type: "number"
            }, null, 8, _hoisted_27), [
              [_vModelText, b.from]
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              class: "btn btn-danger",
              onClick: ($event: any) => (_ctx.removeBand(b))
            }, "Remove", 8, _hoisted_29)
          ])
        ]))
      }), 128)),
      (_ctx.modelError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.modelError), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("button", {
            class: "btn btn-success",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.process && _ctx.process(...args)))
          }, "Process")
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createVNode(_component_k_drop_down_list, {
            id: "metric",
            modelValue: _ctx.metric,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.metric) = $event)),
            class: "form-control",
            "data-items": _ctx.allMetrics
          }, null, 8, ["modelValue", "data-items"])
        ]),
        (_ctx.data)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("button", {
                class: "btn btn-success",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.downloadOnClient && _ctx.downloadOnClient(...args)))
              }, " Download ")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.busy)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, " working... "))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.error), 1))
        : (_ctx.data)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("div", {
                class: "px-3 mb-1 cohort-row cohort-row-headers d-flex flex-row flex-nowrap",
                style: _normalizeStyle(_ctx.dataRowStyle)
              }, [
                _hoisted_39,
                _hoisted_40,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.cohorts[0].Data, (d) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: d.ColumnName,
                    class: "cohort-row__data"
                  }, [
                    _createElementVNode("div", null, _toDisplayString(d.ColumnName), 1)
                  ]))
                }), 128)),
                _hoisted_41
              ], 4),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.cohorts, (c) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${c.StartDate}-${c.RevenueBand.From}`,
                  class: _normalizeClass(["px-3 py-1 cohort-row d-flex flex-row flex-nowrap", c.Even ? 'cohort-row-even' : 'cohort-row-odd']),
                  style: _normalizeStyle(_ctx.dataRowStyle)
                }, [
                  _createElementVNode("div", _hoisted_42, _toDisplayString(c.StartDateString), 1),
                  _createElementVNode("div", _hoisted_43, _toDisplayString(c.RevenueBand.Name), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.Data, (d, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: d.ColumnName,
                      class: "cohort-row__data"
                    }, [
                      (_ctx.metric === 'Revenue')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(d.GbpAmounts.toFixed(0)), 1))
                        : _createCommentVNode("", true),
                      (_ctx.metric === 'Revenue Percent')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(d.GbpAmountsPercent.toFixed(i ? 1 : 0)), 1))
                        : _createCommentVNode("", true),
                      (_ctx.metric === 'People')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(d.ActiveUsers.toFixed(0)), 1))
                        : _createCommentVNode("", true),
                      (_ctx.metric === 'People Percent')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(d.ActiveUsersPercent.toFixed(i ? 1 : 0)), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  _hoisted_48
                ], 6))
              }), 128))
            ]))
          : _createCommentVNode("", true)
  ], 64))
}